 
import uptimeLogoDark from 'images/logos/uptime-logo-dark.svg';
import uptimeLogoLight from 'images/logos/uptime-logo-light.svg';
import { useTheme } from 'styled-components';
import { lightTheme } from 'hfs-common-ui';
import { automationIds } from 'core/test-ids';
import * as S from './styled';

interface Props {
  size?: number;
}
const Logo = ({ size = 200 }: Props) => {
  const theme = useTheme();
  const logo = theme === lightTheme ? uptimeLogoLight : uptimeLogoDark;
  return (
    <S.LogoContainer>
      <S.LogoImage id={automationIds.utcLogo} src={logo} alt="Husqvarna Uptime Center" size={size} />
    </S.LogoContainer>
  );
};

export default Logo;
